import React, { useEffect, useState, useRef } from 'react';

import { Button, Table } from 'antd';
import { T } from 'react-translator-component';
import styled from 'styled-components';

import { ListPagination } from './ListPagination/ListPagination';

import { getChargeboxTask, getTasks } from '../../hooks/operations';
import { COLORS } from '../../utils/theme/colors';

interface IOperationsTasks {
  mode: string;
}

const OperationsTasks = ({ mode }: IOperationsTasks): any => {
  const [tasks, setTasks] = useState<any>({});
  const [paginatedTasks, setPaginatedTasks] = useState<any[]>([]);
  const [selectedTask, setSelectedTask] = useState<any>({});
  const [operationResultSource, setOperationResultSource] = useState<any>({});
  const paginationRef = useRef<any>();

  const tasksColumns = [
    {
      title: T('Task ID'),
      dataIndex: 'taskId',
      key: 'taskId',
      render: (text) => <a>{text}</a>,
    },
    {
      title: T('OCPP Version'),
      dataIndex: 'ocppVersion',
      key: 'ocppVersion',
    },
    {
      title: T('Operation Name'),
      dataIndex: 'operationName',
      key: 'operationName',
    },
    {
      title: T('Origin'),
      dataIndex: 'origin',
      key: 'origin',
    },
    {
      title: T('Start Timestamp'),
      dataIndex: 'startTimestamp',
      key: 'startTimestamp',
    },
    {
      title: T('End Timestamp'),
      dataIndex: 'endTimestamp',
      key: 'endTimestamp',
    },
  ];

  const columns = [
    {
      title: 'Key',
      dataIndex: 'key',
      key: 'key',
      render: (text: React.ReactNode) => <a>{text}</a>,
    },
    {
      title: 'Value',
      dataIndex: 'value',
      key: 'value',
    },
  ];

  useEffect(() => {
    (async () => {
      setTasks(await getTasks());
    })();
  }, [mode]);

  useEffect(() => {
    (async () => {
      if (selectedTask?.taskId) {
        const taskData = await getChargeboxTask({
          chargeBoxId: Object.keys(selectedTask?.taskDetail?.resultMap)[0],
          taskId: selectedTask?.taskId,
        });
        setOperationResultSource(taskData);
      }
    })();
  }, [selectedTask]);

  const data =
    operationResultSource?.response?.configurationKeys?.length &&
    operationResultSource?.response?.configurationKeys.map(
      (obj: { key: any; value: any }) => {
        return {
          key: obj.key,
          value: obj.value,
        };
      },
    );

  const scheduleResponse = operationResultSource?.response?.chargingSchedule
    ? operationResultSource.response
    : null;

  const schedulePeriodColumns = [
    {
      title: T('Start Period (in sec)'),
      dataIndex: 'startPeriod',
      key: 'startPeriod',
    },
    {
      title: T('Power Limit'),
      dataIndex: 'limit',
      key: 'limit',
    },
    {
      title: T('Number Phases'),
      dataIndex: 'numberPhases',
      key: 'numberPhases',
    },
  ];

  const schedulePeriodData =
    scheduleResponse?.chargingSchedule?.chargingSchedulePeriod?.map(
      (period: any, index: number) => ({
        key: index,
        startPeriod: period.startPeriod,
        limit: period.limit,
        numberPhases: period.numberPhases,
      }),
    ) || [];

  return mode === 'tasks' ? (
    <OperationsTasksWrapper>
      <OperationsTasksFlexRow>
        <div>
          <span className='box_title'>{T('Tasks')}</span>
          <Container>
            <Table
              style={{ minWidth: '400px' }}
              size='small'
              pagination={false}
              columns={tasksColumns}
              dataSource={paginatedTasks?.map((task: any, index: any) => {
                return {
                  key: index,
                  taskId: task.taskId,
                  ocppVersion: task.taskDetail.ocppVersion,
                  operationName: task.taskDetail.operationName,
                  origin: task.origin,
                  startTimestamp: task.startTimestamp,
                  endTimestamp: task.endTimestamp,
                };
              })}
              expandable={{
                expandedRowRender: (record) => {
                  const expandedTask = paginatedTasks[record.key];

                  return (
                    <div>
                      {Object.keys(expandedTask.taskDetail.resultMap).map(
                        (task, index) => {
                          const details =
                            expandedTask.taskDetail.resultMap[task];
                          return (
                            <TaskDetailResultRow key={index}>
                              <div>
                                {task !== null && (
                                  <p>
                                    <strong>{T('ChargeBox ID')}:</strong> {task}
                                  </p>
                                )}
                                {details.errorMessage !== null && (
                                  <p>
                                    <strong>{T('Error Message')}:</strong>{' '}
                                    {`${details.errorMessage}`}
                                  </p>
                                )}
                                {details.response !== null && (
                                  <p>
                                    <strong>{T('Response')}:</strong>{' '}
                                    {`${details.response}`}
                                  </p>
                                )}
                                <p>
                                  {details.hasDetail ? (
                                    <Button
                                      onClick={() => {
                                        setSelectedTask(
                                          tasks?.taskList?.find(
                                            (task) =>
                                              task.taskId ===
                                              expandedTask.taskId,
                                          ),
                                        );
                                      }}
                                    >
                                      Ver detalhes
                                    </Button>
                                  ) : null}
                                </p>
                              </div>
                            </TaskDetailResultRow>
                          );
                        },
                      )}
                    </div>
                  );
                },
                rowExpandable: () => true,
              }}
            />
            {tasks?.taskList?.length > 0 && (
              <ListPagination
                ownRef={paginationRef}
                pureData={tasks.taskList}
                callback={(newPageData) => setPaginatedTasks(newPageData)}
              />
            )}
          </Container>
        </div>
      </OperationsTasksFlexRow>
      {selectedTask?.taskId && (
        <div>
          <span className='box_title_green'>
            Resultado Task Id {selectedTask.taskId}
          </span>
          <Container>
            {scheduleResponse ? (
              <ScheduleSummary>
                <p>
                  <strong>{T('ChargeBox ID')}:</strong>{' '}
                  {operationResultSource?.chargeBoxId}
                </p>
                <p>
                  <strong>{T('Connector ID')}:</strong>{' '}
                  {scheduleResponse.connectorId}
                </p>
                <p>
                  <strong>{T('Schedule Start')}:</strong>{' '}
                  {scheduleResponse.scheduleStart}
                </p>
                <p>
                  <strong>{T('Duration (in seconds)')}:</strong>{' '}
                  {scheduleResponse.chargingSchedule?.duration}
                </p>
                <p>
                  <strong>{T('Start Schedule')}:</strong>{' '}
                  {scheduleResponse.chargingSchedule?.startSchedule}
                </p>
                <p>
                  <strong>{T('Charging Rate Unit')}:</strong>{' '}
                  {scheduleResponse.chargingSchedule?.chargingRateUnit}
                </p>
                <p>
                  <strong>{T('Min Charging Rate')}:</strong>{' '}
                  {scheduleResponse.chargingSchedule?.minChargingRate}
                </p>
                <Table
                  style={{ minWidth: '400px' }}
                  size='small'
                  columns={schedulePeriodColumns}
                  dataSource={schedulePeriodData}
                />
              </ScheduleSummary>
            ) : (
              <Table
                style={{ minWidth: '400px' }}
                size='small'
                columns={columns}
                dataSource={data}
              />
            )}
          </Container>
        </div>
      )}
    </OperationsTasksWrapper>
  ) : null;
};

const OperationsTasksWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  padding: 2em;
`;

const OperationsTasksFlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  flex-wrap: wrap;
  max-width: 1000px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  border: 1px solid ${COLORS.stone};
  border-radius: 2px;
  margin: 0.5em 1em 0.5em 0;
  padding: 1em;
`;

const TaskDetailResultRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  border: 1px solid ${COLORS.stone};
  border-radius: 2px;
  margin: 0.5em 1em 0.5em 0;
  padding: 1em;

  p {
    color: ${COLORS.primary};

    strong {
      color: #000;
      font-weight: bolder;
    }
  }
`;

const ScheduleSummary = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;

  p {
    margin: 0 0 0.25em 0;

    strong {
      font-weight: bolder;
    }
  }
`;

export default OperationsTasks;
